import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  Grid,
  Row,
  Col,
  Panel,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Payment.css';
import { FormattedMessage, formatMessage, injectIntl } from 'react-intl';
import * as FontAwesome from 'react-icons/lib/fa';

import { connect } from 'react-redux';

// Component
import PaymentDetails from './PaymentDetails';
import PaymentForm from './PaymentForm';
import ListCoverPhoto from '../../ListCoverPhoto';
import CurrencyConverter from '../../CurrencyConverter';

// Helper
import bookingCalculations from '../../../helpers/bookingCalculations';
import { convert } from '../../../helpers/currencyConvertion';
import { daysCountWithoutWeekends } from '../../../helpers/pleXpad';
import pMath from '../../../helpers/pMath';

// Locale
import messages from '../../../locale/messages';

// Stripe
import { loadStripe } from '@stripe/stripe-js';
import { ElementsConsumer, Elements } from '@stripe/react-stripe-js';

// Configuration
import { payment } from '../../../config';

const stripePromise = loadStripe(payment.stripe.publishableKey);

//Images
import RightArrowIcon from '../../../../public/rightArrow.svg';
import WorkSpaceIcon from '../../../../public/SiteImages/schreibtisch.svg';

class Payment extends Component {

  static stripePromise;

  static propTypes = {
    listId: PropTypes.number.isRequired,
    hostId: PropTypes.string.isRequired,
    guestId: PropTypes.string,
    guestEmail: PropTypes.string,
    hostDisplayName: PropTypes.string.isRequired,
    hostPicture: PropTypes.string,
    coverPhoto: PropTypes.any,
    listTitle: PropTypes.string.isRequired,
    allowedPersonCapacity: PropTypes.number.isRequired,
    listType: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    houseRules: PropTypes.arrayOf(PropTypes.shape({
      listsettings: PropTypes.shape({
        itemName: PropTypes.string.isRequired
      })
    })),
    checkIn: PropTypes.object.isRequired,
    checkOut: PropTypes.object,
    guests: PropTypes.number.isRequired,
    basePrice: PropTypes.number.isRequired,
    cleaningPrice: PropTypes.number,
    currency: PropTypes.string.isRequired,
    weeklyDiscount: PropTypes.number,
    monthlyDiscount: PropTypes.number,
    listPhotos: PropTypes.array,
    serviceFees: PropTypes.shape({
      guest: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired
      }).isRequired,
      host: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    base: PropTypes.string.isRequired,
    rates: PropTypes.object.isRequired,
    bookingType: PropTypes.string.isRequired,
    policyName: PropTypes.string.isRequired,
    formatMessage: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.stripePromise = stripePromise;
  }

  componentDidUpdate(prevProps) {
    const { monthlyPass, monthlyPassSubscriptionStage } = this.props;

    if( monthlyPass && !prevProps.monthlyPassSubscriptionStage && monthlyPassSubscriptionStage ) {
      this.stripePromise = loadStripe(payment.stripe.publishableKey);
    }
  }

  render() {
    const { originalIsAuthenticated } = this.props;
    const { isAuthenticated, account } = this.props;
    const { hostDisplayName, coverPhoto, listPhotos, bookingType, policyName } = this.props;
    const { listId, listTitle, city, state, country, allowedPersonCapacity } = this.props;
    const { formatMessage } = this.props.intl;
    const { houseRules, hostId } = this.props;
    const { guests, useFreeTrial, monthlyPass, monthlyPassAuthDeposit, monthlyPassSubscriptionStage, monthPass, checkIn, checkOut, taxRate, projectTicketmaster } = this.props;
    const { basePrice, promoPrice, monthlyPassPrice, monthlyPassPromoPrice, monthPassPrice, cleaningPrice, currency, weeklyDiscount, monthlyDiscount } = this.props;
    const { serviceFees, base, rates, isHotDesking, isOpenOnWeekends, freeTrialDays, bookingData } = this.props;

    let guestId = '', guestEmail = '';

    if( isAuthenticated && account ) {
      guestId = account.userId;
      guestEmail = account.email;
    }
    
    let guestServiceFee = 0, hostServiceFee = 0, hostServiceFeeType = '', hostServiceFeeValue = 0;
    let discount = 0, discountType = null, priceForDays = 0, total = 0, authorisationAmount = 0;
    let stayLengthBillable, averageDayRate = 0;
    let bookingPricing = [], isSpecialPriceAssigned = false;
    let subTotal = 0, taxAmount = 0, totalLessServiceFee = 0, subTotalLessDiscount = 0;
    let workSpaceLabel = allowedPersonCapacity > 1 ? formatMessage(messages.workSpaces) : formatMessage(messages.workSpace);

    let freeTrialDaysCount = 0;

    let promoDays = 0;

    const monthlyPassIsSubscription = !monthlyPassPromoPrice && monthlyPass && daysCountWithoutWeekends(new Date(), new Date(checkIn)) <= 6;

    let passType = monthlyPass ? 'monthlyPass' : ( monthPass ? 'monthPass' : 'standard' );
    switch( passType ) {
      case 'monthlyPass': {
        ({ monthlyPassSubTotal: subTotal, monthlyPassTaxAmount: taxAmount } = bookingCalculations.monthlyPass({basePrice, isOpenOnWeekends, monthlyPass, monthlyPassPrice, isHotDesking, guests, taxRate}));
        /* subTotal = monthlyPassPrice;
        if( isHotDesking ) subTotal *= guests; */
        subTotalLessDiscount = subTotal;
        break;
      }
      case 'monthPass': {
        ({ monthPassSubTotal: subTotal, monthPassTaxAmount: taxAmount } = bookingCalculations.monthPass({basePrice, isOpenOnWeekends, monthPass, monthPassPrice, isHotDesking, guests, taxRate}));
        /* subTotal = monthPassPrice;
        if( isHotDesking ) subTotal *= guests; */
        subTotalLessDiscount = subTotal;
        break;
      }
      default: {
        if (checkIn != null && checkOut != null) {
          ({ freeTrialDaysCount, stayLengthBillable, isSpecialPriceAssigned, averageDayRate, priceForDays, subTotalLessDiscount, discount, discountType, guestServiceFee, subTotal, taxAmount, total, promoDays } = bookingCalculations.standardBooking({
            basePrice,
            promoPrice,
            cleaningPrice,
            currency,
            monthlyDiscount,
            weeklyDiscount,
            startDate: checkIn,
            endDate: checkOut,
            serviceFees,
            base,
            rates,
            specialPricing: bookingData.listBlockedPrice,
            taxRate,
            isHotDesking,
            isOpenOnWeekends,
            freeTrialDays,
            guests,
            useFreeTrial,
            projectTicketmaster,
            formatMessage
          }));
          
          //New 
          /* if (stayLength > 0) {

            let stayedDays = [];
            // Find stayed nights
            for (let i = 0; i < stayLength; i++) {
              let currentDate = moment(checkIn).add(i, 'day');
              if( isOpenOnWeekends == true || currentDate.toDate().getDay() != 0 && currentDate.toDate().getDay() != 6 ) stayedDays.push(currentDate);
            }

            if (stayedDays && stayedDays.length > 0) {
              stayedDays.map((item, key) => {
                let isSpecialPricing;
                if (item) {
                  let pricingRow, currentPrice;
                  currentDay = (moment(item).format('dddd').toLowerCase());
                  
                  if( freeTrialDaysRemaining ) {
                    currentPrice = 0;
                    ++freeTrialDaysCount;
                    --freeTrialDaysRemaining;
                    --stayLengthBillable;
                  }
                  else {
                    // isSpecialPricing = specialPricing.find(o => moment(item).format('MM/DD/YYYY') == moment(o.blockedDates).format('MM/DD/YYYY'));
                    isSpecialPricing = bookingData && bookingData.listBlockedPrice.find(o => moment(item).format('MM/DD/YYYY') == moment(o.blockedDates).format('MM/DD/YYYY'));

                    if (isSpecialPricing && isSpecialPricing.isSpecialPrice) {
                      isSpecialPriceAssigned = true;
                      currentPrice = Number(isSpecialPricing.isSpecialPrice);
                    } else {
                      currentPrice = Number(basePrice);
                    }
                  }
                  // Price object
                  pricingRow = {
                    blockedDates: item,
                    dayPrice: currentPrice,
                  };
                  bookingPricing.push(pricingRow);
                }
              });
            }
          }

          bookingPricing.map((item, index) => {
            priceForDays = priceForDays + Number(item.dayPrice);
          }); */
        }

        /* averageDayRate = stayLengthBillable > 0 ? Number(priceForDays) / Number(stayLengthBillable) : 0;
        subTotal = pMath.round(averageDayRate, 2) * stayLengthBillable;
        if( isHotDesking ) subTotal *= guests;

        if (stayLengthBillable >= (isOpenOnWeekends == true ? 7 : 5)) {
          if (monthlyDiscount > 0 && stayLengthBillable >= (isOpenOnWeekends == true ? 28 : 21)) {
            discount = (Number(subTotal) * Number(monthlyDiscount)) / 100;
            discountType = monthlyDiscount + "% " + formatMessage(messages.monthlyDiscount);
          } else if( weeklyDiscount > 0 ) {
            discount = (Number(subTotal) * Number(weeklyDiscount)) / 100;
            discountType = weeklyDiscount + "% " + formatMessage(messages.weeklyDiscount);
          }
        } */
        break;
      }
    }

    /* taxAmount = taxRate && taxRate > 0 ? ((subTotalLessDiscount + cleaningPrice) * (Number(taxRate) / 100)) : 0; */
    totalLessServiceFee = (subTotal + cleaningPrice + taxAmount);

    if( projectTicketmaster ) {
      hostServiceFeeType = 'percentage';
      hostServiceFeeValue = 0.04;
      hostServiceFee = pMath.round(totalLessServiceFee * hostServiceFeeValue);
    }
    else if (serviceFees) {
      if (serviceFees.guest.type === 'percentage') {
        guestServiceFee = totalLessServiceFee * (Number(serviceFees.guest.value) / 100);
      } else {
        guestServiceFee = convert(base, rates, serviceFees.guest.value, serviceFees.guest.currency, currency);
      }

      if (serviceFees.host.type === 'percentage') {
        hostServiceFeeType = serviceFees.host.type;
        hostServiceFeeValue = serviceFees.host.value;
        hostServiceFee = totalLessServiceFee * (Number(serviceFees.host.value) / 100);
      } else {
        hostServiceFeeType = serviceFees.host.type;
        hostServiceFeeValue = serviceFees.host.value;
        hostServiceFee = convert(base, rates, serviceFees.host.value, serviceFees.host.currency, currency);
      }
      guestServiceFee = pMath.round(guestServiceFee, 2);
      hostServiceFee = pMath.round(hostServiceFee, 2);
    }

    let checkInStart = bookingData.listingData.checkInStart;
    let checkInEnd = bookingData.listingData.checkInEnd;

    total = totalLessServiceFee + guestServiceFee;

    if( monthlyPass ) {
      authorisationAmount = pMath.round((monthlyPassPromoPrice ? monthlyPassPromoPrice : total)/2);
    }

    let checkInDate = checkIn != null ? moment(moment(checkIn).format('YYYY-MM-DD')).format('ddd, Do MMM') : '';
    let checkOutDate = checkOut != null ? moment(moment(checkOut).format('YYYY-MM-DD')).format('ddd, Do MMM') : '';

    let initialValues = {
      listId,
      listTitle,
      hostId,
      guestId,
      guests,
      freeTrialDaysCount,
      message: '',
      checkIn,
      checkOut,
      basePrice,
      currency,
      cleaningPrice,
      discount,
      discountType,
      guestServiceFee,
      hostServiceFee,
      total,
      authorisationAmount,
      bookingType,
      paymentType: 2,
      paymentCurrency: currency,
      guestEmail,
      isSpecialPriceAssigned,
      bookingPricing: JSON.stringify(bookingPricing),
      isSpecialPriceAverage: averageDayRate.toFixed(2),
      isHotDesking,
      isOpenOnWeekends,
      monthPass,
      monthlyPass,
      dayDifference: stayLengthBillable != null ? stayLengthBillable-1 : null,
      taxRate,
      taxAmount,
      checkInStart,
      checkInEnd,
      hostServiceFeeType,
      hostServiceFeeValue,
      name: ''
    };

    return (
      <Grid>
        <Row>
          <Col lg={6} md={6} sm={6} xs={12} className={cx(s.space3, s.paddingRight)}>
            <div className={s.listingTitleSection}>
              <div className={s.postionRelative}>
                <ListCoverPhoto
                  className={cx(s.bannerImage, s.backgroundCover)}
                  coverPhoto={coverPhoto}
                  listPhotos={listPhotos}
                  photoType={"x_medium"}
                  bgImage
                />
                <div className={s.listingTitleSectionPadding}>
                  <p className={s.stateTxt}>{city}, {state}, {country}</p>
                  <h2 className={cx(s.listTitleText, s.space2)}>{listTitle}</h2>
                  <p className={cx(s.stateTxt, s.space3)}>
                    <img src={WorkSpaceIcon} className={s.listingImage} />
                    <span>{allowedPersonCapacity} {workSpaceLabel}</span>
                  </p>
                  <hr className={s.horizondalLine} />
                  <div className={s.spaceTop2}>
                    <Row>
                      <Col xs={5} sm={5}>
                        <div className={cx(s.textGray, s.space1, s.checkInText)}>
                          <span><FormattedMessage {...messages.checkIn} /></span>
                        </div>
                        <div className={s.checkInDate}>{checkInDate}</div>
                      </Col>
                      <Col xs={1} sm={1}>
                        <img src={RightArrowIcon} className={s.arrowIcon} />
                      </Col>
                      {
                      (checkOutDate) && <Col xs={5} sm={5} className={cx(s.pullRight)}>
                        <div className={cx(s.textGray, s.space1, s.checkInText)}>
                          <span><FormattedMessage {...messages.checkOut} /></span>
                        </div>
                        <div className={s.checkInDate}>{checkOutDate}</div>
                      </Col>
                      }
                    </Row>
                    <hr className={s.horizondalLine} />
                  </div>
                  <div className={s.spaceTop2}>
                    <Row>
                      <Col xs={6} sm={7} md={7} lg={7}>
                        <p>Provider</p>
                      </Col>
                      <Col xs={6} sm={5} md={5} lg={5}>
                        {hostDisplayName}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={12} className={cx(s.space3, s.paddingLeft)}>
            <div className={cx(s.listingTitleSection, s.priceDetailBorder)}>
              <div className={s.listingTitleSectionPadding}>
                <h3 className={cx(s.h3, s.paymentText)}>{total == 0 || monthlyPassAuthDeposit ? <FormattedMessage {...messages.authorisation} /> : ( (isAuthenticated) ? <FormattedMessage {...messages.payment} /> : <FormattedMessage {...messages.checkout} /> )}</h3>
                {total == 0 && <h4 className={cx(s.h4)}>{formatMessage(messages.authorisationNote).split('[[amountCurrency]]').map((e, i) => {
                  return i ? e : [e, <CurrencyConverter amount={1} from={currency} />];
                })}</h4>}
                {
                  monthlyPassAuthDeposit ?
                  <div className={cx(s.monthlyPassAuthorisationRequired)}>
                    {formatMessage(messages.monthlyPassAuthorisationRequired).split('[[amountCurrency]]').map((e, i) => {
                      return i ? e : [e, <strong><CurrencyConverter amount={authorisationAmount} from={currency} /></strong>];
                    })}
                  </div>
                  :
                  ((monthlyPass || monthPass) ?
                  <React.Fragment>
                    <div>
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                          <table className={cx('table', s.noMargin)}>
                            <tbody>
                              <tr className={s.tableText}>
                                <td className={cx(s.noBorder, s.tableDataPdding)}>
                                  <span className={cx(s.specialPriceText, 'directionLtrTextRight')}>
                                    <CurrencyConverter
                                      amount={monthlyPass ? monthlyPassPrice : monthPassPrice}
                                      from={currency}
                                    /> <FormattedMessage {...monthlyPass ? messages.monthlyPass : messages.monthsPass} />
                                    { (isHotDesking) && <span>{' x'} {guests} {guests > 1 ? formatMessage(messages.guests) : formatMessage(messages.guest)}</span> }
                                  </span>
                                </td>
                                <td className={cx(s.noBorder, 'text-right', s.tableDataPdding)}>
                                  <span>
                                    <CurrencyConverter
                                      amount={subTotal}
                                      from={currency}
                                    />
                                  </span>
                                </td>
                              </tr>
                              {
                                cleaningPrice > 0 && <tr className={s.tableText}>
                                  <td className={cx(s.tableDataBorder, s.tableDataPdding)}><FormattedMessage {...messages.cleaningFee} /></td>
                                  <td className={cx(s.tableDataBorder, 'text-right', s.tableDataPdding)}>
                                    <span>
                                      <CurrencyConverter
                                        amount={cleaningPrice}
                                        from={currency}
                                      />
                                    </span>
                                  </td>
                                </tr>
                              }
                              {
                                taxRate > 0 && <tr className={s.tableText}>
                                  <td className={cx(s.noBorder, s.tableDataPdding)}><FormattedMessage {...messages.VAT} /> @{taxRate}%</td>
                                  <td className={cx(s.noBorder, 'text-right', s.tableDataPdding)}>
                                    <span>
                                      <CurrencyConverter
                                        amount={taxAmount}
                                        from={currency}
                                      />
                                    </span>
                                  </td>
                                </tr>
                              }
                              {
                                guestServiceFee > 0 && <tr className={s.tableText}>
                                  <td className={cx(s.tableDataBorder, s.tableDataPdding)}><FormattedMessage {...messages.serviceFee} /></td>
                                  <td className={cx(s.tableDataBorder, 'text-right', s.tableDataPdding)}>
                                    <span>
                                      <CurrencyConverter
                                        amount={guestServiceFee}
                                        from={currency}
                                      />
                                    </span>
                                  </td>
                                </tr>
                              }
                              {
                                discount > 0 && <tr className={s.tableText}>
                                  <td className={cx(s.tableDataBorder, s.tableDataPdding)}>{discountType}</td>
                                  <td className={cx(s.tableDataBorder, 'text-right', s.tableDataPdding)}>
                                    - <span>
                                      <CurrencyConverter
                                        amount={discount}
                                        from={currency}
                                      />
                                    </span>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </Col>
                      </Row>
                    </div>
                    <div className={cx(s.totalValue, s.space2)}>
                        <table className={cx('table', s.noMargin)}>
                          <tbody>
                            <tr className={s.totalText}>
                              <td className={cx(s.tableDataBorder, s.tableDataPdding)}><FormattedMessage {...messages.total} /></td>
                              <td className={cx(s.tableDataBorder, 'text-right', s.tableDataPdding)}>
                                <span>
                                  <CurrencyConverter
                                    amount={total}
                                    from={currency}
                                  />
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                    </div>
                  </React.Fragment>
                  :
                  <PaymentDetails
                    basePrice={basePrice}
                    promoPrice={promoPrice}
                    promoDays={promoDays}
                    cleaningPrice={cleaningPrice}
                    currency={currency}
                    stayLengthBillable={stayLengthBillable}
                    freeTrialDaysCount={freeTrialDaysCount}
                    priceForDays={priceForDays}
                    subTotal={subTotal}
                    discount={discount}
                    discountType={discountType}
                    serviceFees={guestServiceFee}
                    total={total}
                    bookingPricing={bookingPricing}
                    isSpecialPriceAssigned={isSpecialPriceAssigned}
                    isHotDesking={isHotDesking}
                    isOpenOnWeekends={isOpenOnWeekends}
                    freeTrialDays={freeTrialDays}
                    guests={guests}
                    useFreeTrial={useFreeTrial}
                    isAverage={averageDayRate}
                    taxRate={taxRate}
                    taxRateFee={taxAmount}
                  />)
                }
                {
                  /**Todo: take into account currency decimal places*/
                }
                <Elements
                  stripe={this.stripePromise}
                  options={{
                    mode: monthlyPass && monthlyPassSubscriptionStage ? (monthlyPassIsSubscription ? 'subscription' : 'setup') : 'payment',
                    ...!monthlyPass || !monthlyPassSubscriptionStage || monthlyPassIsSubscription ? {amount: Math.round((monthlyPass && monthlyPassAuthDeposit ? authorisationAmount : total)*100)} : {},
                    currency: currency.toLowerCase(),
                    ...monthlyPass && monthlyPassSubscriptionStage ? {
                      ...!monthlyPassIsSubscription ? {
                        setupFutureUsage: 'off_session'
                      } : {},
                      paymentMethodTypes: ['bacs_debit']
                    } : {},
                    appearance: {
                      theme: 'stripe',
                      variables: {
                        colorPrimary: '#E8505B',
                        colorBackground: '#ffffff',
                        colorText: '#767676',
                        colorDanger: '#E8505B',
                        fontFamily: '"Lexend", Arial, Helvetica, sans-serif',
                        fontSizeBase: '14px',
                        spacingUnit: '3px',
                        borderRadius: '10px',
                      },
                      rules: {
                        '.Input': {
                          border: 'none',
                          borderBottom: '1px solid #F2F2F2',
	                        borderRadius: 0,
                          boxShadow: 'none'
                        },
                        '.Input:focus': {
                          outline: 'none',
                          boxShadow: 'none'
                        },
                        '.Label': {
                          fontSize: '13px'
                        }
                      }
                    }
                  }}
                >
                  <ElementsConsumer>
                    {({stripe, elements}) => (
                      <PaymentForm
                        originalIsAuthenticated={originalIsAuthenticated}
                        stripe={stripe}
                        elements={elements}
                        hostDisplayName={hostDisplayName}
                        houseRules={houseRules}
                        allowedPersonCapacity={allowedPersonCapacity}
                        initialValues={initialValues}
                        paymentType={initialValues.paymentType}
                        listId={listId}
                        isHotDesking={isHotDesking}
                        isOpenOnWeekends={isOpenOnWeekends}
                        freeTrialDays={freeTrialDays}
                        guests={guests}
                        monthlyPass={monthlyPass}
                        monthlyPassAuthDeposit={monthlyPassAuthDeposit}
                        monthlyPassSubscriptionStage={monthlyPassSubscriptionStage}
                        monthlyPassIsSubscription={monthlyPassIsSubscription}
                      />
                    )}
                  </ElementsConsumer>
                </Elements>
                <div className={s.textAlignCenter}>
                  <span className={s.cancellationPolicyText}><FormattedMessage {...messages.cancellationPolicy} />: </span>
                  <span className={s.policyColor}>{policyName}</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Grid >
    );
  }
}

const mapState = (state) => ({
	isAuthenticated: state.runtime.isAuthenticated,
  account: state.account.data,
  monthlyPassAuthDeposit: state.book.bookDetails.monthlyPassAuthDeposit,
  monthlyPassSubscriptionStage: state.book.bookDetails.monthlyPassSubscriptionStage
});

const mapDispatch = {};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(Payment)));


// WEBPACK FOOTER //
// src/components/Booking/Payment/Payment.js